import React from 'react';
//Components
import moment from 'moment';
import AnalysesByEmployeeOptions from './analysesByEmployeeOptions.jsx';
import AnalysesByEmployeeSummary from './analysesByEmployeeSummary.jsx';
import Loader from '../../../../components/loader.jsx';
import {FormattedMessage} from 'react-intl';

import ReportApi from '../../../../../api/report.jsx';

class AnalysesByEmployee extends React.Component {
  state = {
    data: [],
    filters: [],
    loaded: true,
    showNoDataMessage: false,
  };

  componentWillMount() {
    let date = new Date();
    let filters = {
      dateFrom: moment(new Date(date.setMonth(date.getMonth() - 1))),
      dateTo: moment(new Date()),
      store: 0,
    };

    this.setState({
      filters: filters,
    });
  }

  updateReportData = (dateFrom, dateTo, branch) => {
    let filters = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      branch: branch,
    };

    this.setState({
      data: [],
      loaded: false,
    });
    ReportApi.getWaterAnalysesByEmployeeSummary(dateFrom, dateTo, branch)
            .then(res => {
              if(res && res.TotalEmployees > 0) {
                this.setState({
                  data: res,
                  filters: filters,
                  showNoDataMessage: false,
                });
              } else {
                this.setState({showNoDataMessage: true});
              }
              this.setState({loaded: true});
            }).catch((e) => {
              console.log(e);
              this.setState({loaded: true,showNoDataMessage: true});
            });
  };

  render() {
    return (
      <div className="report-container">
        <span>
          <FormattedMessage id="reports.analyses.employee.description" />
        </span>
        <AnalysesByEmployeeOptions updateReportData={this.updateReportData} branches={this.props.branches} defaultFilters={this.state.filters} />
        <Loader loaded={this.state.loaded}>
          <AnalysesByEmployeeSummary
					data={this.state.data}
					filters={this.state.filters}
					POSActive={this.props.POSActive}
					showNoDataMessage={this.state.showNoDataMessage}
					/>
        </Loader>
      </div>
    );
  }
}

export default AnalysesByEmployee;
